import { TextSwitch } from "react-migration/components/TextSwitch";
import { Theme } from "react-migration/lib/theme/Theme";
import { Tooltip } from "react-migration/components/Tooltip";
import { ComparablesState } from "react-migration/domains/comparables/typings/Comparables";

export type ComparablesDataSourceSwitchProps = {
  dataSource: ComparablesState["dataSource"];
  onDataSourceChange: (dataSource: ComparablesState["dataSource"]) => void;
};

export const ComparablesDataSourceSwitch = ({ dataSource, onDataSourceChange }: ComparablesDataSourceSwitchProps) => {
  return (
    <TextSwitch name="comparables-source" value={dataSource} className="">
      <TextSwitch.Label value="hmlr" onToggle={onDataSourceChange}>
        <span>
          HMLR
          <Tooltip.Wrapper>
            <Tooltip.Trigger>
              <i className="icon-lt-information-line cursor-pointer text-sm pl-1 text-neutral-400" />
            </Tooltip.Trigger>
            <Tooltip.Content align="center" side="top" theme={Theme.Light} size="sm">
              <span className="whitespace-normal">
                Provided by HMLR, whom are responsible for registering the ownership of land and property
              </span>
            </Tooltip.Content>
          </Tooltip.Wrapper>
        </span>
      </TextSwitch.Label>
      <TextSwitch.Label value="hometrack" onToggle={onDataSourceChange}>
        <span>
          Hometrack
          <Tooltip.Wrapper>
            <Tooltip.Trigger>
              <i className="icon-lt-information-line cursor-pointer text-sm pl-1 text-neutral-400" />
            </Tooltip.Trigger>
            <Tooltip.Content align="center" side="top" theme={Theme.Light} size="sm">
              <span className="whitespace-normal">
                Unparalleled and accurate property market intelligence from the experts – Zoopla and Hometrack
              </span>
            </Tooltip.Content>
          </Tooltip.Wrapper>
        </span>
      </TextSwitch.Label>
    </TextSwitch>
  );
};
